import styled from 'styled-components';
import { colors, ApButtonOrange } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: ${colors.white};
`;

export const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
`;

export const BottomSection = styled.div`
  display: flex;
  padding: 12px 0;
  align-items: center;
  justify-content: center;
  border-top: 2px solid ${colors.amber};
`;

export const PublishButton = styled(ApButtonOrange)`
  margin-left: 40px;
`;

export const Text = styled.div`
  color: ${colors.grey7};
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.3px;
  line-height: 19px;
`;
